module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Password_nascondi_Light Blue.c7602a97.svg";